
const IntroPage = () => {

  return (
    <section id='intro'>
      <h1 className='me_header'>Who am I?</h1>
    
      <div className="background">
        Hello! I'm a dynamic individual with a diverse background living in Washington D.C.
        I embody a unique blend of skills and experiences.
        My journey as a Marine veteran has instilled in me discipline, resilience, 
        and a profound sense of duty.
        As a software engineer, I thrive where my problem-solving abilities and passion for innovation come to the forefront. 
        <br />
        Beyond the realms of coding, I am a dedicated climate activist, 
        driven by a deep concern for our planet's well-being. 
        As a mixologist, I craft not only cocktails but also memorable experiences, 
        infusing creativity into every concoction. 
        Through my varied pursuits, 
        I seek to contribute to positive change, whether by creating delightful libations, 
        solving complex technical challenges, 
        or advocating for a sustainable future. 
      </div>
    </section>
  );
};

export default IntroPage; 
